const AutoCADNetApiCourse = {
    id: "autocad-net-api",

    name: "AutoCAD .NET API Automation & Customization Training",
syllabusPdf: "/syllabus/Autocad-API-Syllabus.pdf",

    hero: {
        title: "AutoCAD .NET API Automation & Customization Training",
 subtitle: "Live & Interactive Online Training",
        logo: "/AutoCAD.webp",

        points: [
            "Master AutoCAD automation and customization using .NET APIs (C# or VB.NET). Automate drafting, geometry creation, and CAD workflows directly within AutoCAD to boost productivity and precision.",

            "Transform your career from manual drafting to intelligent design automation using AutoCAD .NET API and Autodesk customization best practices.",

            "Perfect for engineers, architects, and CAD professionals aiming for high-paying roles and rapid career advancement through advanced AutoCAD scripting and automation skills.",

            "No programming experience? No problem. The training starts with computer programming basics and gradually builds up to powerful API-level automation techniques.",

            "Proven Global Success: Our students are working at industry leaders including Autodesk, Honeywell, KONE, Tata Technologies, ITC Infotech, Kennametal & Many more"
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "“For CAD Design Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, CAD Developers with the same experience can command CTCs of 20 Lakhs to 30 Lakhs.”"
        },
        {
            title: "Good Demand",
            description:
                "“While CAD Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, CAD Automation & Customization is a niche expertise, with only a few engineers.”"
        },
        {
            title: "Easier To Learn",
            description:
                "“While CAD Design is generally easier to learn, CAD Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training.”"
        }
    ],

    whyLearn: [
        {
            title: "Automate Repetitive Drafting Tasks",
            description:
                "Eliminate time-consuming manual work by creating scripts and programs that perform tasks like layer creation, dimensioning, and block insertion automatically."
        },
        {
            title: "High-Demand Skill in AEC & Manufacturing",
            description:
                "Professionals with AutoCAD customization expertise are highly sought after in architecture, engineering, construction, and manufacturing industries."
        },
        {
            title: "Unlock Higher Salaries",
            description:
                "CAD engineers with automation and programming skills earn more than traditional drafters or designers due to their advanced capabilities."
        },
        {
            title: "Work Smarter, Not Harder",
            description:
                "Design and execute intelligent commands that think and react to your design environment, reducing human error and rework."
        },
        {
            title: "Build Your Own Design Tools",
            description:
                "Create custom commands, toolbars, palettes, and add-ins to streamline your workflow and improve team productivity."
        },
        {
            title: "Handle Complex Projects with Ease",
            description:
                "Programmatically generate drawings, reports, and BOMs — ideal for handling repetitive work across large-scale projects."
        },
        {
            title: "In-Demand Worldwide",
            description:
                "Global engineering and construction firms rely on automation to scale operations and are always looking for skilled AutoCAD developers."
        },
        {
            title: "Career Advancement in R&D & BIM",
            description:
                "Move beyond drafting into roles involving CAD system development, BIM integration, and parametric design."
        },
        {
            title: "Integrate with Other Systems",
            description:
                "Use the AutoCAD API to connect drawings with Excel, databases, ERP/PLM systems, and more — enabling data-driven design."
        },
        {
            title: "Future-Proof Your Career",
            description:
                "With AI and automation reshaping industries, mastering CAD automation prepares you for the future of intelligent design engineering."
        }
    ],

   syllabus: [
        {
            name: "C#.NET",
            modules: [
                {
                    number: 1,
                    title: "Environment Setup & Basics",
                    topics: [
                        "Setting up Visual Studio",
                        "Basic Syntax & Program Structure",
                        "Data Types & Variables",
                        "Constants & Modifiers",
                        "Statements & Operators",
                        "Using Math Functions"
                    ]
                },
                {
                    number: 2,
                    title: "Control Flow",
                    topics: [
                        "Decision Making (if, else, switch)",
                        "Looping (for, while, do-while)",
                        "Working with Strings",
                        "Date & Time Manipulations"
                    ]
                },
                {
                    number: 3,
                    title: "Arrays & Functions",
                    topics: [
                        "One-dimensional Arrays",
                        "Multi-dimensional Arrays (2D & 3D)",
                        "Function Declaration & Calling",
                        "Arguments, Return Types",
                        "out and ref Parameters"
                    ]
                },
                {
                    number: 4,
                    title: "Collections & Data Structures",
                    topics: [
                        "Collections Overview",
                        "List, ArrayList",
                        "Dictionary, Hashtable"
                    ]
                },
                {
                    number: 5,
                    title: "Object-Oriented Programming (OOP)",
                    topics: [
                        "Structs and Enums",
                        "Classes & Objects",
                        "Constructors & Destructors",
                        "Access Levels (public, private, protected)",
                        "Stack vs Heap Memory",
                        "Static Classes & Methods"
                    ]
                },
                {
                    number: 6,
                    title: "Advanced OOP Concepts",
                    topics: [
                        "Abstract Classes & Methods",
                        "Interfaces",
                        "Inheritance (Single, Multiple, Multilevel)",
                        "Polymorphism",
                        "Method Overloading",
                        "Method Overriding"
                    ]
                },
                {
                    number: 7,
                    title: "Exception & File Handling",
                    topics: [
                        "Exception Handling (try, catch, finally)",
                        "File Handling (Create, Read, Write, Delete)",
                        "Directory Handling"
                    ]
                },
                {
                    number: 8,
                    title: "Application Development",
                    topics: [
                        "Creating Console Applications",
                        "Windows Forms Basics",
                        "Form Controls & Layout",
                        "Dialog Boxes",
                        "Advanced Forms & Event Handling"
                    ]
                },
                {
                    number: 9,
                    title: "Libraries & External Integration",
                    topics: [
                        "Creating Class Libraries & DLLs",
                        "Interacting with Notepad Files",
                        "Reading/Writing Excel Files",
                        "Key Visual Studio Functions (Debugging, Build Tools, etc.)"
                    ]
                }
            ]
        },

        {
            name: "AutoCAD .NET API",
            modules: [
                {
                    number: 1,
                    title: "Getting Started with AutoCAD .NET API",
                    topics: [
                        "Overview of the AutoCAD .NET API",
                        "Key Components of the API",
                        "AutoCAD Object Hierarchy Explained",
                        "In-Process vs Out-of-Process Applications",
                        "Using AutoCAD Core Console for Automation"
                    ]
                },
                {
                    number: 2,
                    title: "Visual Studio Integration",
                    topics: [
                        "Introduction to Microsoft Visual Studio",
                        "Working with Visual Studio Projects & Solutions",
                        "Project Components and Structure",
                        "Editing Existing Projects",
                        "Accessing Libraries via the Object Browser",
                        "Error Handling and Debugging in C#"
                    ]
                },
                {
                    number: 3,
                    title: "Command & User Interaction",
                    topics: [
                        "Defining Custom AutoCAD Commands",
                        "Accessing the AutoCAD Command Line",
                        "Prompting for User Input (Numbers, Points, Strings)",
                        "Object Selection Handling",
                        "Controlling the AutoCAD Application & Drawing Windows"
                    ]
                },
                {
                    number: 4,
                    title: "Drawing Management",
                    topics: [
                        "Creating New Drawings",
                        "Opening, Saving & Closing Drawings Programmatically",
                        "Document Locking & Unlocking",
                        "Setting AutoCAD Preferences",
                        "Managing System Variables"
                    ]
                },
                {
                    number: 5,
                    title: "Precision Drawing & Object Creation",
                    topics: [
                        "Drawing with Precision: Coordinates, Snaps, and Geometry",
                        "Creating and Editing Entities (Lines, Circles, Polylines, etc.)",
                        "Opening, Modifying, and Closing Objects",
                        "Creating Custom Objects",
                        "Working with Selection Sets"
                    ]
                },
                {
                    number: 6,
                    title: "Layer & Visual Styles",
                    topics: [
                        "Managing Layers Programmatically",
                        "Applying Colors and Linetypes",
                        "Saving and Restoring Layer States"
                    ]
                },
                {
                    number: 7,
                    title: "Annotation Automation",
                    topics: [
                        "Adding Text to Drawings",
                        "Dimensioning Concepts",
                        "Creating and Editing Dimensions",
                        "Managing Dimension Styles",
                        "Adding Tolerances"
                    ]
                },
                {
                    number: 8,
                    title: "Working with Blocks",
                    topics: [
                        "Looping Through All Blocks and Block References",
                        "Using Block Matrices",
                        "Reading & Editing Attributes in Block References",
                        "Reading & Editing Dynamic Block Parameters"
                    ]
                },
                {
                    number: 9,
                    title: "Advanced Data Handling",
                    topics: [
                        "Working with External References (XRefs)",
                        "Assigning and Retrieving Extended Data (XData)",
                        "Using XRecord to Store/Retrieve Custom Information"
                    ]
                },
                {
                    number: 10,
                    title: "UI and Events",
                    topics: [
                        "Integrating Windows Forms UI Inside AutoCAD",
                        "Managing AutoCAD Events (Document Events, Command Events, etc.)"
                    ]
                }
            ]
        }
    ],

    faq: [
        {
            question: "What is AutoCAD API?",
            answer:
                "The AutoCAD API, or AutoCAD Application Programming Interface, is a set of tools and functions provided by Autodesk to customize and extend the capabilities of AutoCAD software. It allows developers to create custom applications, automate tasks, and integrate specialized design tools with AutoCAD."
        },
        {
            question: "How Much Salary?",
            answer:
                "CAA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.\n\nFor a detailed explanation, please view the video located at this page."
        },
        {
            question: "I Have AutoCAD Design Experience",
            answer:
                "Having CAD design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CAD tools.\n\nYou can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.\n\nIn the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
        },
        {
            question: "Job Guaranteed?",
            answer:
                "Generally No.\nSometimes Yes.\nPlease speak to the coordinator for more details."
        },
        {
            question: "Which Programming Language?",
            answer:
                "For CAD tools such as NX, AutoCAD, SolidWorks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages"
        },
        {
            question: "Job Opportunities?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ],

    videos: [
        {
            category: "What is CAD Customization? ( Explained using real project)",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=1\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F\\&vf=1"
        },
        {
            category: "CAD Customization & Automation",
            title: "What is CAD Customization and Automation?",
            videoUrl:
                "https://www.youtube.com/embed/0TB3m21GMO8?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=3\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F\\&vf=1"
        },
        {
            category: "Real first Day programming class",
            title: "Day 1: Programming Class C#.NET",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=5\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F\\&vf=1"
        },
        {
            category: "Sample Creo Toolkit customization Project",
            title: "Sample Creo Toolkit Automation & Customization",
            videoUrl:
                "https://www.youtube.com/embed/poccCwHW7ok?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=7\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F\\&vf=1"
        },
        {
            category: "Revit API sample project Rebar Automation",
            title: "Revit API Sample Project Geometry Concept Demo",
            videoUrl:
                "https://www.youtube.com/embed/YhbgQvxbJ98?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=9\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautocad-api-customization-automation-online-courses%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F\\&vf=1"
        }
    ]
};

export default AutoCADNetApiCourse;